import { HttpClient } from '@wix/http-client';
var isSSR = typeof window === 'undefined';
var httpClient = new HttpClient({ isSSR: isSSR, timeout: 10000 });
export { httpClient };
//# sourceMappingURL=http-client.js.map